import React, { useState } from "react";
import { Modal, Form, DatePicker, Input, Descriptions } from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { markAsSent } from "../../api/outsourceApi";

const SendToVendorModal = ({ visible, outsourceJob, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await markAsSent(outsourceJob.id, {
        tracking_number: values.tracking_number,
        notes: values.notes,
      });
      toast.success("Marked as sent to vendor");
      form.resetFields();
      onSuccess();
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to update status"
      );
    }
    setLoading(false);
  };

  return (
    <Modal
      title={`Send to Vendor: ${outsourceJob?.outsource_number || ""}`}
      open={visible}
      onCancel={onCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      destroyOnClose
    >
      {outsourceJob && (
        <Descriptions
          size="small"
          column={1}
          bordered
          style={{ marginBottom: 16 }}
        >
          <Descriptions.Item label="Vendor">
            {outsourceJob.vendor?.name}
          </Descriptions.Item>
          <Descriptions.Item label="Service">
            {outsourceJob.service_type?.replace(/_/g, " ").toUpperCase()}
          </Descriptions.Item>
          <Descriptions.Item label="Quantity">
            {outsourceJob.sent_quantity?.toLocaleString() ||
              outsourceJob.quantity?.toLocaleString()}
          </Descriptions.Item>
        </Descriptions>
      )}

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ sent_date: dayjs() }}
      >
        <Form.Item name="tracking_number" label="Tracking / Challan No.">
          <Input placeholder="TRK-12345 or DC-001" />
        </Form.Item>

        <Form.Item name="notes" label="Dispatch Notes">
          <Input.TextArea
            rows={2}
            placeholder="Vehicle number, driver name, courier details..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default SendToVendorModal;
